import { Country } from "@/data/constants/country";
import { formatSymbol } from "@/utils/i18n/format-symbol";

export const overview = {
  zh: {
    analysis: (symbol: string) => `${formatSymbol(symbol)} AI 分析 & 策略健檢`,
    instruction: (symbol: string) => `${formatSymbol(symbol)} 整體評價`,
    performance: (symbol: string) => `${formatSymbol(symbol)} 近期報酬表現`,
    highRelevance: (symbol: string) =>
      `與 ${formatSymbol(symbol)} 同產業的標的表現`,
    keyMetrices: (symbol: string) => `${formatSymbol(symbol)} 重點圖表`,
    profile: (symbol: string) => `${formatSymbol(symbol)} 公司資訊`,
    sameIndustry: "同產業平均",
    price: (symbol: string) => `${formatSymbol(symbol)} 股價`,
    stock: (country: Uppercase<Country>): string =>
      country === "TW" ? "台股" : "美股",
    highRelevanceTable: {
      symbol: "股票代碼",
      company: "公司名稱",
      value: "價值",
      trend: "趨勢",
      swing: "波段",
      chip: "籌碼",
      dividend: "股利",
      watchlist: "加入追蹤",
      score: (score: number) => `${score} 分`,
      viewAll: "查看全部",
      viewLess: "顯示較少",
    },
    metricesCompareMetric: "數據指標",
    metricesCompareValue: "數值",
    metricesCompareVersusIndustry: "v.s. 產業表現",
    seeMore: "查看更多",
    longTermValue: "長線價值",
    trendMomentum: "趨勢動能",
    swingSignal: "波段訊號",
    incomeInvesting: "存股收息",
    keysForBull: "看多重點：",
    conclusion: "分析結論",
    score: ({ orientation, score }: { orientation: string; score: number }) =>
      `${orientation} ${score} 分`,
    earningsTable: {
      quarter: "季度",
      nonGaaPEPS: "Non-GAAP EPS",
      epsYoY: "EPS 年增率",
      epsSurprise: "EPS Surprise %",
      sales: "營收",
      salesYoY: "營收年增率",
      salesSurprise: "營收 Surprise %",
      npm: "淨利率",
      current: "最新一季",
    },
    forecastTable: {
      quarterly: "季度",
      annually: "年度",
      epsForecast: "EPS 預測",
      revenueForecast: "營收預測",
      qoq: "QoQ",
      yoy: "YoY",
      max: "最大值",
      min: "最小值",
    },
  },
  en: {
    analysis: (symbol: string) =>
      `${formatSymbol(symbol)} AI Analysis & Strategy`,
    instruction: (symbol: string) =>
      `Analysis Instruction of ${formatSymbol(symbol)}`,
    performance: (symbol: string) =>
      `${formatSymbol(symbol)} Current Performance`,
    highRelevance: (symbol: string) =>
      `Top 10 High Relevance to ${formatSymbol(symbol)}`,
    keyMetrices: (symbol: string) => `${formatSymbol(symbol)} Key Information`,
    profile: (symbol: string) => `${formatSymbol(symbol)} Profile`,
    sameIndustry: "Avg of Sector",
    price: (symbol: string) => `Price of ${formatSymbol(symbol)}`,
    stock: (country: Uppercase<Country>): string =>
      country === "TW" ? "TW Stock" : "US Stock",
    highRelevanceTable: {
      symbol: "Symbol",
      company: "Company Name",
      value: "Value",
      trend: "Trend",
      swing: "Swing Trading",
      chip: "Whale Interest",
      dividend: "Dividend",
      watchlist: "Add to Watchlist",
      score: (score: number) => `${score}`,
      viewAll: "View All",
      viewLess: "View Less",
    },
    metricesCompareMetric: "METRIC",
    metricesCompareValue: "VALUE",
    metricesCompareVersusIndustry: "VS INDUSTRY",
    seeMore: "See more",
    longTermValue: "Long-term Value",
    trendMomentum: "Trend Momentum",
    swingSignal: "Swing Signal",
    incomeInvesting: "Income Investing",
    keysForBull: "Keys for Bullish View",
    conclusion: "Analysis Conclusion",
    score: ({ orientation, score }: { orientation: string; score: number }) =>
      `${orientation}: ${score}`,
    earningsTable: {
      quarter: "QTR",
      nonGaaPEPS: "Non-GAAP EPS",
      epsYoY: "EPS YoY",
      epsSurprise: "EPS Surprise %",
      sales: "Sales",
      salesYoY: "Sales YoY",
      salesSurprise: "Sales Surprise %",
      npm: "NPM",
      current: "Current",
    },
    forecastTable: {
      quarterly: "Quarterly",
      annually: "Annually",
      epsForecast: "EPS Forecast",
      revenueForecast: "Revenue Forecast",
      qoq: "QoQ",
      yoy: "YoY",
      max: "Max",
      min: "Min",
    },
  },
};
